import { exportBalanceTransactionsCSV, getBalanceTransactions } from '@/services/asicw/balance.service'
import type { IBalanceTransactionFilters } from '@/types/asicw/balance'
import { useMutation, useQuery } from '@tanstack/vue-query'
import type { ComputedRef } from 'vue'

export function useBalanceTransactions() {
  const getBalanceTransactionsQuery = (
    filters: IBalanceTransactionFilters,
    enabled: ComputedRef<boolean> | boolean = true
  ) => {
    return useQuery({
      queryKey: ['asicw-billing', 'balance-transactions', filters],
      queryFn: () => getBalanceTransactions(filters),
      enabled,
    })
  }

  const exportBalanceTransactionsMutation = useMutation({
    mutationFn: (filters: IBalanceTransactionFilters) => exportBalanceTransactionsCSV(filters),
  })

  return {
    getBalanceTransactionsQuery,
    exportBalanceTransactionsMutation,
  }
}
